var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputNumber',_vm._g(_vm._b({},'InputNumber',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }